import { ArrowRight, FileClock, FileSignature, Layers3 } from "lucide-react";
import { Link } from "react-router-dom";
import { Badge, Card } from "../components/ui";
import { useTenantRuntime } from "../config/TenantRuntime";
import { FLOW_PRODUCT_MODULES } from "../data/flow-modules";

export function FlowOverviewPage() {
  const { hasModule } = useTenantRuntime();
  const enabledCount = FLOW_PRODUCT_MODULES.filter(({ module }) => hasModule(module)).length;

  return (
    <div className="page-stack">
      <div className="notice">
        <Layers3 size={21} />
        <div>
          <strong>EVA Flow · contratos e recebíveis para qualquer negócio</strong>
          <p>
            Gerencie contratos e valores a receber de produtos da Yatta ou do próprio parceiro. Os
            módulos comerciais são independentes e podem ser habilitados conforme a operação.
          </p>
        </div>
      </div>

      <div className="three-feature-grid">
        <Link className="feature-navigation-card" to="/contratos">
          <FileSignature size={23} />
          <div>
            <strong>Contratos</strong>
            <span>Base central da operação</span>
          </div>
          <ArrowRight size={17} />
        </Link>
        <Link className="feature-navigation-card" to="/recebiveis">
          <FileClock size={23} />
          <div>
            <strong>Recebíveis</strong>
            <span>Obrigações de qualquer origem</span>
          </div>
          <ArrowRight size={17} />
        </Link>
        <Link className="feature-navigation-card" to="/produtos">
          <Layers3 size={23} />
          <div>
            <strong>Produtos disponíveis</strong>
            <span>{enabledCount} de 6 módulos habilitados</span>
          </div>
          <ArrowRight size={17} />
        </Link>
      </div>

      <Card
        title="Módulos comerciais"
        description="Cada parceiro escolhe os produtos que usa; contratos e recebíveis permanecem no núcleo da plataforma."
      >
        <div className="product-grid">
          {FLOW_PRODUCT_MODULES.map((product) => (
            <div className="feature-navigation-card" key={product.module}>
              <div>
                <strong>{product.name}</strong>
                <span>{product.description}</span>
              </div>
              <Badge tone={hasModule(product.module) ? "success" : "info"}>
                {hasModule(product.module) ? "Habilitado" : "Disponível"}
              </Badge>
              {hasModule(product.module) && (
                <Link className="text-link" to={product.path}>
                  Abrir
                </Link>
              )}
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
